import React, { useEffect, useState, memo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "../styles/findyourfloors.css";
import { Link } from "react-router-dom";
import { getFindYourFloors } from "../services/FindYourFloors.service";

const FindYourFloors = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   const fetchBanners = async () => {
  //     try {
  //       const banners = await getFindYourFloors();
  //       setImages(banners);
  //     } catch (err) {
  //       setError("Unable to load banners. Please try again later.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchBanners();
  // }, []);

  useEffect(() => {
  const fetchBanners = async () => {
    try {
      const response =
        await getFindYourFloors();
      console.log(
        "BANNER RESPONSE:",
        response
      );

      // FIX images.map error
      let bannerArray = [];

      if (Array.isArray(response)) {
        bannerArray = response;
      } else if (
        Array.isArray(response?.data)
      ) {
        bannerArray = response.data;
      } else if (
        Array.isArray(
          response?.banners
        )
      ) {
        bannerArray =
          response.banners;
      }

      setImages(bannerArray);

    } catch (err) {
      console.error(err);

      setImages([]);

      setError(
        "Unable to load banners. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  fetchBanners();
}, []);

  if (loading) return <div>Loading banners...</div>;
  if (error) return <div>{error}</div>;
  if (images.length === 0) return <div>No banners found.</div>;

   // Agar API no data hide section
   
  if (
  !Array.isArray(images) ||
  images.length === 0
) {
  return null;
}

  return (
    <div className="swiper-container-box">
      <div className="matcher-content-heading">
        <h2>The Right Rug Awaits</h2>
        <p>We’ll help you match it with the right floor covering.</p>
        <Link to="/floor-matcher">
          <button className="finder-button">TRY FLOOR MATCHER</button>
        </Link>
      </div>

      <div className="slider-wrapper">
        <Swiper
          modules={[EffectCoverflow, Pagination, Autoplay]}
          effect="coverflow"
          centeredSlides={true}
          loop={true}
          slidesPerView="auto"
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          speed={800}
          pagination={{ clickable: true }}
          coverflowEffect={{
            rotate: 0,
            stretch: 100,
            depth: 150,
            modifier: 1.5,
            slideShadows: false,
          }}
        >
           {Array.isArray(images) &&
             images.map((item, index) => (
            <SwiperSlide key={index} className="slide-item">
              <div className="slider-image">
                <img src={item.media} alt={`slide-${item.id || index}`} loading="lazy" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
export default memo(FindYourFloors);